import { render } from "./VehicleBpmSearch.vue?vue&type=template&id=52ec898a"
import script from "./VehicleBpmSearch.vue?vue&type=script&lang=js"
export * from "./VehicleBpmSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__